import React from 'react';
import './App.css';
import { Link } from 'react-router-dom'; // Import Link
import { FaArrowRight, FaClock } from 'react-icons/fa';

const Insights = () => {
  const articles = [
    {
      id: 1,
      category: "Artificial Intelligence",
      title: "The Generative AI Advantage in Financial Services",
      date: "October 12, 2025",
      // Robot Image
      image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 2,
      category: "Sustainability",
      title: "Decarbonizing the Supply Chain: A Tactical Guide",
      date: "September 28, 2025",
      // Container Ship for Supply Chain
      image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=600&q=80"
    },
    {
      id: 3,
      category: "Cloud Transformation",
      title: "Legacy to Cloud: Avoiding the Common Pitfalls",
      date: "September 15, 2025",
      // Earth Image
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=600&q=80"
    }
  ];

  return (
    <div className="page-fade-in">
      {/* Featured Insight Hero */}
      <div className="container" style={{paddingTop: '4rem', paddingBottom: '4rem'}}>
        <span className="section-label">Featured Insight</span>
        <div className="hero" style={{borderBottom: 'none', minHeight: '60vh'}}>
          <div className="hero-content">
            <h1 style={{fontSize: '3.5rem'}}>State of AI 2025: From Experiment to Value.</h1>
            <p style={{color: '#a1a1a1', fontSize: '1.2rem', margin: '2rem 0'}}>
              While 90% of organizations have piloted AI, only 10% are seeing scalable value. 
              Our latest report breaks down the barriers to adoption.
            </p>
            {/* Featured Button Link */}
            <Link to="/article" className="btn btn-primary">Read the Report</Link>
          </div>
          <div className="hero-img-container" style={{height: '50vh'}}>
             <img 
              src="https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1200&q=80" 
              alt="AI Brain" 
              className="hero-img"
            />
          </div>
        </div>
      </div>

      {/* Latest Thinking Grid */}
      <div className="services" style={{paddingTop: '0'}}>
        <div className="container">
          <h2 className="section-title">Latest Perspectives</h2>
          <div className="grid-3">
            {articles.map((art, index) => (
              // WRAPPER LINK to Makes the whole card clickable
              <Link to="/article" className="card" key={index} style={{padding: '0', overflow: 'hidden', display:'flex', flexDirection:'column', textDecoration:'none'}}>
                
                {/* Article Image */}
                <div style={{height: '250px', width:'100%', overflow: 'hidden'}}>
                  <img src={art.image} alt={art.title} style={{width:'100%', height:'100%', objectFit:'cover', transition:'transform 0.5s'}} />
                </div>
                
                {/* Article Content */}
                <div style={{padding: '2rem', display:'flex', flexDirection:'column', flexGrow: 1}}>
                  <span style={{color: '#00a40e', fontSize: '0.8rem', fontWeight: '700', textTransform: 'uppercase'}}>
                    {art.category}
                  </span>
                  <h3 style={{fontSize: '1.5rem', marginTop: '10px', marginBottom: '15px', color:'#fff'}}>
                    {art.title}
                  </h3>
                  <div style={{display: 'flex', alignItems: 'center', color: '#666', fontSize: '0.9rem', marginTop:'auto'}}>
                    <FaClock style={{marginRight: '8px'}} /> {art.date}
                  </div>
                  <div style={{marginTop: '2rem', display: 'flex', alignItems: 'center', color: '#fff', fontWeight: '700'}}>
                    Read Article <FaArrowRight style={{marginLeft: '10px', color: '#00a40e'}} />
                  </div>
                </div>

              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Insights;